import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePlanReviewCategoryMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  set: Types.Plan_Review_Categories_Set_Input;
}>;


export type UpdatePlanReviewCategoryMutation = { __typename?: 'mutation_root', update_plan_review_categories_by_pk?: { __typename?: 'plan_review_categories', id: any } | null };


export const UpdatePlanReviewCategoryDocument = gql`
    mutation updatePlanReviewCategory($id: uuid!, $set: plan_review_categories_set_input!) {
  update_plan_review_categories_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdatePlanReviewCategoryMutationFn = Apollo.MutationFunction<UpdatePlanReviewCategoryMutation, UpdatePlanReviewCategoryMutationVariables>;

/**
 * __useUpdatePlanReviewCategoryMutation__
 *
 * To run a mutation, you first call `useUpdatePlanReviewCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanReviewCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanReviewCategoryMutation, { data, loading, error }] = useUpdatePlanReviewCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdatePlanReviewCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanReviewCategoryMutation, UpdatePlanReviewCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanReviewCategoryMutation, UpdatePlanReviewCategoryMutationVariables>(UpdatePlanReviewCategoryDocument, options);
      }
export type UpdatePlanReviewCategoryMutationHookResult = ReturnType<typeof useUpdatePlanReviewCategoryMutation>;
export type UpdatePlanReviewCategoryMutationResult = Apollo.MutationResult<UpdatePlanReviewCategoryMutation>;
export type UpdatePlanReviewCategoryMutationOptions = Apollo.BaseMutationOptions<UpdatePlanReviewCategoryMutation, UpdatePlanReviewCategoryMutationVariables>;